import { useCallback, useEffect, useState } from 'react'

import { api, ErrorApi, type EstadoUsuario, type Usuario } from '../api'

const FILTROS: { valor: EstadoUsuario | undefined; texto: string }[] = [
  { valor: 'pendiente', texto: 'Pendientes' },
  { valor: 'aprobado', texto: 'Aprobados' },
  { valor: 'rechazado', texto: 'Rechazados' },
  { valor: undefined, texto: 'Todos' },
]

export function Usuarios() {
  const [filtro, setFiltro] = useState<EstadoUsuario | undefined>('pendiente')
  const [usuarios, setUsuarios] = useState<Usuario[]>([])
  const [error, setError] = useState('')

  const cargar = useCallback(async () => {
    try {
      const { usuarios } = await api.usuarios(filtro)
      setUsuarios(usuarios)
      setError('')
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo cargar.')
    }
  }, [filtro])

  useEffect(() => {
    void cargar()
  }, [cargar])

  const decidir = async (id: string, accion: 'aprobar' | 'rechazar') => {
    try {
      await api.decidirUsuario(id, accion)
      await cargar()
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo guardar.')
    }
  }

  return (
    <section>
      <div className="encabezado">
        <div>
          <h1>Usuarios</h1>
          <p className="suave">Quien se registra no entra hasta que lo apruebes.</p>
        </div>
      </div>

      <div className="filtros">
        {FILTROS.map((f) => (
          <button
            key={f.texto}
            className={filtro === f.valor ? 'chip activo' : 'chip'}
            onClick={() => setFiltro(f.valor)}
          >
            {f.texto}
          </button>
        ))}
      </div>

      {error && <p className="error">{error}</p>}
      {usuarios.length === 0 && !error && <p className="vacio">No hay usuarios en esta lista.</p>}

      {usuarios.length > 0 && (
        <div className="tabla-envoltura">
          <table className="tabla">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Correo</th>
                <th>Rol</th>
                <th>Estado</th>
                <th>Registrado</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {usuarios.map((u) => (
                <tr key={u.id} className="sin-clic">
                  <td className="fuerte">{u.nombre}</td>
                  <td>{u.correo}</td>
                  <td>{u.rol}</td>
                  <td>
                    <span className={`insignia insignia-${u.estado}`}>{u.estado}</span>
                  </td>
                  <td className="suave">{new Date(u.created_at).toLocaleDateString('es-EC')}</td>
                  <td className="acciones">
                    {u.rol === 'asesor' && u.estado !== 'aprobado' && (
                      <button className="primario pequeno" onClick={() => decidir(u.id, 'aprobar')}>
                        Aprobar
                      </button>
                    )}
                    {u.rol === 'asesor' && u.estado !== 'rechazado' && (
                      <button className="secundario pequeno" onClick={() => decidir(u.id, 'rechazar')}>
                        {u.estado === 'aprobado' ? 'Quitar acceso' : 'Rechazar'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
